export const AVATAR_PATH = 'avatars/';
export const AVATAR_DEFAULT_NAME_SVG = '{{randomNumber}}_default.svg';
export const AVATAR_COUNT_MAX = 10;
export const AVATAR_DEFAULT_NAME = 'default';
